import {
  EquipRequestDTO,
  EquipResponseDTO,
  EquipResponseSchema,
  EquipmentSlot,
  HexCoordinateDTO,
  InventoryDropResponseDTO,
  InventoryDropResponseSchema,
  UseItemRequestDTO,
  UseItemResponseDTO,
  UseItemResponseSchema,
} from '@hexcrawl/shared-utils';
import { requestJson } from './api.ts';

export const inventoryApiService = {
  /** Spends a consumable on the map. `targetHex` is only used by hex-targeted items. */
  useItem(gameId: string, instanceId: string, targetHex?: HexCoordinateDTO): Promise<UseItemResponseDTO> {
    const data: UseItemRequestDTO = { gameId, instanceId, targetHex };
    return requestJson<UseItemResponseDTO>({
      url: '/game/use-item',
      method: 'POST',
      data,
      schema: UseItemResponseSchema,
    });
  },

  dropItem(characterId: string, instanceId: string): Promise<InventoryDropResponseDTO> {
    return requestJson<InventoryDropResponseDTO>({
      url: '/character/inventory/drop',
      method: 'POST',
      data: { characterId, instanceId },
      schema: InventoryDropResponseSchema,
    });
  },

  equipItem(characterId: string, instanceId: string, slot: EquipmentSlot): Promise<EquipResponseDTO> {
    const data: EquipRequestDTO = { characterId, instanceId, slot };
    return requestJson<EquipResponseDTO>({
      url: '/character/inventory/equip',
      method: 'POST',
      data,
      schema: EquipResponseSchema,
    });
  },

  unequipItem(characterId: string, slot: EquipmentSlot): Promise<EquipResponseDTO> {
    return requestJson<EquipResponseDTO>({
      url: '/character/inventory/unequip',
      method: 'POST',
      data: { characterId, slot },
      schema: EquipResponseSchema,
    });
  },
};
